import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Ubah Konversi ", -1)
const _hoisted_5 = { class: "inline-flex" }
const _hoisted_6 = {
  key: 1,
  class: "flex flex-row h-full"
}
const _hoisted_7 = { class: "w-2/3 pr-4 text-12px xxl:text-14px pb-24" }
const _hoisted_8 = { class: "pt-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-500 w-4/5" }, " Pastikan nilai kurs awal, kurs tukar, dan periode konversi tidak boleh sama dengan data yang sedang aktif. ", -1)
const _hoisted_10 = { class: "grid grid-cols-2 gap-4 w-3/4 mt-4" }
const _hoisted_11 = { class: "flex-grow truncate block appearance-none text-12px xxl:text-14px w-full text-gray-lp-600 bg-white border border-gray-lp-400 px-4 py-2 pr-16 rounded leading-tight focus:outline-none mt-2 cursor-not-allowed" }
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = { class: "flex-grow truncate block appearance-none text-12px xxl:text-14px w-full text-gray-lp-600 bg-white border border-gray-lp-400 px-4 py-2 pr-16 rounded leading-tight focus:outline-none mt-2 cursor-not-allowed" }
const _hoisted_14 = { class: "font-semibold" }
const _hoisted_15 = { class: "inline-flex flex-row w-full mt-2" }
const _hoisted_16 = { class: "bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2" }
const _hoisted_17 = /*#__PURE__*/_createVNode("input", {
  type: "text",
  value: "1",
  placeholder: "1",
  class: "py-1.5 xxl:py-3 px-3 rounded-l-none rounded-r-md bg-white border border-gray-lp-400 focus:outline-none focus:shadow text-gray-lp-600 w-full cursor-not-allowed",
  disabled: ""
}, null, -1)
const _hoisted_18 = { class: "inline-flex flex-row w-full mt-2" }
const _hoisted_19 = { class: "bg-gray-lp-700 rounded-l-md text-black-lp-300 text-center border-gray-lp-400 border outline-none focus:shadow items-center py-1.5 xxl:py-3 text-12px xxl:text-14px px-2" }
const _hoisted_20 = { class: "mt-4 pt-4 border-t border-gray-lp-400" }
const _hoisted_21 = { class: "py-3" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Tanggal efektif ", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "my-2 text-gray-lp-500" }, " Konfigurasi ini akan berlaku seterusnya sejak tanggal yang dipilih hingga Anda memperbaruinya. ", -1)
const _hoisted_24 = { class: "flex flex-row py-3" }
const _hoisted_25 = { class: "w-3/4" }
const _hoisted_26 = { class: "flex flex-col mr-4 w-11/12" }
const _hoisted_27 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_28 = { class: "py-3" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Status ", -1)
const _hoisted_30 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_31 = { class: "flex" }
const _hoisted_32 = { class: "capitalize font-medium" }
const _hoisted_33 = { class: "py-3" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal dibuat", -1)
const _hoisted_35 = { class: "my-1 text-black-lp-300" }
const _hoisted_36 = { class: "text-gray-lp-500" }
const _hoisted_37 = { class: "py-3" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir diubah", -1)
const _hoisted_39 = { class: "my-1 text-black-lp-300" }
const _hoisted_40 = { class: "text-gray-lp-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Pickers = _resolveComponent("Pickers")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer",
                alt: "back"
              }),
              _hoisted_4
            ]),
            _createVNode("div", _hoisted_5, [
              _withDirectives(_createVNode(_component_button_fill, {
                title: "Simpan",
                onClick: _ctx.onOpenSave,
                isDisabled: _ctx.isDisabled,
                class: "px-8 bg-red-lp-300"
              }, null, 8, ["onClick", "isDisabled"]), [
                [_vShow, !_ctx.isError]
              ])
            ])
          ]),
          (_ctx.isError)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 0,
                errorType: _ctx.errorCause,
                onTryAgain: _ctx.getDetail
              }, null, 8, ["errorType", "onTryAgain"]))
            : (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode("div", _hoisted_10, [
                      _createVNode(_component_DataWrapper, { label: "Kurs awal" }, {
                        default: _withCtx(() => [
                          _createVNode("span", _hoisted_11, [
                            _createTextVNode(_toDisplayString(_ctx.detailData?.exchangeRateCountryNameFrom) + " - ", 1),
                            _createVNode("span", _hoisted_12, _toDisplayString(_ctx.detailData?.exchangeRateFrom), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataWrapper, { label: "Kurs tukar" }, {
                        default: _withCtx(() => [
                          _createVNode("span", _hoisted_13, [
                            _createTextVNode(_toDisplayString(_ctx.detailData?.exchangeRateCountryNameTo) + " - ", 1),
                            _createVNode("span", _hoisted_14, _toDisplayString(_ctx.detailData?.exchangeRateTo), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataWrapper, { label: "Nilai awal" }, {
                        default: _withCtx(() => [
                          _createVNode("div", _hoisted_15, [
                            _createVNode("div", _hoisted_16, _toDisplayString(_ctx.detailData.exchangeRateFrom), 1),
                            _hoisted_17
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataWrapper, { label: "Nilai tukar" }, {
                        default: _withCtx(() => [
                          _createVNode("div", _hoisted_18, [
                            _createVNode("div", _hoisted_19, _toDisplayString(_ctx.detailData.exchangeRateTo), 1),
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                              maxlength: 15,
                              onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.formatted && _ctx.formatted(...args))),
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.exchangeRateValue = $event)),
                              placeholder: "100,000,000",
                              class: "py-1.5 xxl:py-3 px-3 rounded-l-none rounded-r-md border border-gray-lp-400 focus:outline-none focus:shadow text-black-lp-300 w-full"
                            }, null, 544), [
                              [_vModelText, _ctx.exchangeRateValue]
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode("div", _hoisted_20, [
                    _createVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _hoisted_23,
                      _createVNode("div", _hoisted_24, [
                        _createVNode("div", _hoisted_25, [
                          _createVNode("div", _hoisted_26, [
                            _createVNode(_component_Pickers, {
                              disabled: _ctx.detailData.status.toLowerCase() === 'active',
                              modelValue: _ctx.effectiveDate,
                              onSelected: _ctx.inputEffectiveDate,
                              minDate: _ctx.minDate
                            }, null, 8, ["disabled", "modelValue", "onSelected", "minDate"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_27, [
                  _createVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createVNode("div", _hoisted_30, [
                      _createVNode("div", _hoisted_31, [
                        _createVNode("div", {
                          class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.detailData.status.toLowerCase() === 'active'
                      ? 'bg-green-lp-300'
                      : _ctx.detailData.status.toLowerCase() === 'inactive'
                      ? 'bg-red-lp-600'
                      : 'bg-yellow-lp-200'
                  } ${
                    _ctx.detailData.status.toLowerCase() === 'active'
                      ? 'text-green-lp-200'
                      : _ctx.detailData.status.toLowerCase() === 'inactive'
                      ? 'text-red-lp-500'
                      : 'text-yellow-lp-100'
                  }`
                
                        }, [
                          _createVNode("span", _hoisted_32, _toDisplayString(_ctx.setRateStatus(_ctx.detailData.status.toLowerCase())), 1)
                        ], 2)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createVNode("div", _hoisted_35, _toDisplayString(_ctx.createdAt), 1),
                    _createVNode("div", _hoisted_36, _toDisplayString(_ctx.createdBy), 1)
                  ]),
                  _createVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode("div", _hoisted_39, _toDisplayString(_ctx.updatedAt), 1),
                    _createVNode("div", _hoisted_40, _toDisplayString(_ctx.updatedBy), 1)
                  ])
                ])
              ]))
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.goBack,
      title: "Detail berhasil diubah",
      message: 
      `Cek kembali detail konversi kurs <b>${_ctx.detailData.exchangeRateFrom} - ${_ctx.detailData.exchangeRateTo}: ${_ctx.detailData.id}</b>`
    ,
      image: "image-modal-success",
      textSuccess: "Ok",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onEdit,
      onClose: _ctx.onCloseSave,
      title: "Simpan perubahan kurs?",
      message: "Pastikan data kurs yang Anda ubah telah sesuai.",
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.openSave]
    ])
  ], 64))
}